export default "__VITE_ASSET__ulIuFCbb__"